module.exports = __webpack_public_path__ + "img/Rectangle 81.2181a8f5.png";